import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { fmtFecha } from "../../lib/format";
import { PageHeader } from "../../components/PageHeader";
import { StatusBadge } from "../../components/StatusBadge";
import { Button } from "../../components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

const Fuentes = ({ items }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {items.map((f) => (
      <div key={f.fuente} className="border border-slate-200 rounded-lg p-4 bg-white text-sm space-y-1" data-testid={`list-source-${f.fuente}`}>
        <p className="font-semibold">{f.nombre}</p>
        <p className="break-all text-xs"><b>URL:</b> {f.url} · {f.formato}</p>
        <p className="text-xs text-slate-600">{f.nota}</p>
        <p className="text-xs">{f.ultima_ok ? `Vigente: ${fmtFecha(f.ultima_ok.fecha)} · ${f.ultima_ok.registros} registros · hace ${f.edad_horas} h` : "Sin descarga exitosa"}</p>
        {f.ultima_ok && <p className="font-mono text-[11px] break-all">{f.ultima_ok.hash}</p>}
        {f.ultimo_intento?.estado === "error" && <p className="text-xs text-rose-700">Último intento falló: {f.ultimo_intento.error}</p>}
      </div>
    ))}
  </div>
);

export default function Listas() {
  const [d, setD] = useState(null);
  const load = useCallback(() => {
    api.get("/admin/listas").then((r) => setD(r.data));
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const actualizar = async () => {
    await api.post("/admin/listas/actualizar");
    toast.success("Actualización iniciada (tarda 1 a 2 minutos). Recarga para ver el resultado.");
  };
  if (!d) return null;
  return (
    <div className="space-y-8">
      <PageHeader overline="Superadmin" title="Listas ONU, OFAC y PEP">
        <Button onClick={actualizar} data-testid="lists-refresh-button">Actualizar ahora y revisar cartera</Button>
        <Button variant="outline" onClick={load} data-testid="lists-reload-button">Recargar</Button>
      </PageHeader>
      {d.alertas.map((a) => <p key={a} className="text-sm text-rose-700" data-testid="lists-alert">{a}</p>)}
      <Fuentes items={d.fuentes} />
      <div>
        <h2 className="font-heading text-lg font-semibold mb-2">Historial de descargas</h2>
        <Table>
          <TableHeader><TableRow><TableHead>Fecha</TableHead><TableHead>Fuente</TableHead><TableHead>Estado</TableHead><TableHead>Registros</TableHead><TableHead>Cambió</TableHead><TableHead>Hash</TableHead></TableRow></TableHeader>
          <TableBody>
            {d.descargas.map((v) => (
              <TableRow key={v.id}>
                <TableCell>{fmtFecha(v.fecha)}</TableCell><TableCell className="uppercase">{v.fuente}</TableCell>
                <TableCell><StatusBadge value={v.estado === "ok" ? "ok" : "fallido"} label={v.estado} /></TableCell>
                <TableCell>{v.registros ?? "—"}{v.registros_pep ? ` (${v.registros_pep} PEP)` : ""}</TableCell>
                <TableCell>{v.cambio ? "sí" : "no"}</TableCell><TableCell className="font-mono text-[11px]">{(v.hash || v.error || "").slice(0, 24)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <div>
        <h2 className="font-heading text-lg font-semibold mb-2">Alertas al superadmin</h2>
        {d.alertas_superadmin.map((a) => <p key={a.id} className="text-sm">{fmtFecha(a.fecha)} · {a.titulo}</p>)}
        {!d.alertas_superadmin.length && <p className="text-sm text-slate-500">Sin alertas.</p>}
      </div>
    </div>
  );
}
